
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from '../../Fieldset/styles.js';

const Collapse = ({ extraFilters, className }) => {
    return (
        <div
            className={
                css(styles.childContainer_hidden, styles[className])}
        >
            <div className={css(styles.row, styles.rowCondensed)}>
                {extraFilters}
            </div>
        </div>
    );
};

Collapse.propTypes = {
    className: PropTypes.string.isRequired,
    extraFilters: PropTypes.array.isRequired
};

export default Collapse;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/ExtraFiltersCollapse/Collapse/Collapse.jsx